import { useEffect, useState } from 'react';
import { usePlanAccess } from '../../plans/usePlanAccess';
import { SALONFLOW_FEATURES } from '../../plans/salonflowPlans';
import { FinanceiroService } from './Service';

const service = new FinanceiroService();

/** Forma de pagamento padrao do estabelecimento; vazia sem financeiro no plano ou sem configuracao. */
export function useDefaultPaymentMethod(): string | undefined {
    const { hasFeature } = usePlanAccess();
    const enabled = hasFeature(SALONFLOW_FEATURES.FINANCE);
    const [method, setMethod] = useState<string>();

    useEffect(() => {
        if (!enabled) return;
        let active = true;
        service
            .paymentDefault()
            .then((response) => {
                if (active) setMethod(response?.data?.defaultPaymentMethod || undefined);
            })
            .catch((e) => console.error('Erro ao carregar a forma de pagamento padrão', e));
        return () => {
            active = false;
        };
    }, [enabled]);

    return method;
}
